import { Loader } from 'lucide-react';
import { Component } from 'react';

class LoadingData extends Component {
  render() {
    const { isLoading } = this.props;
    return (
      <div
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '600px' }}
      >
        {isLoading && (
          <div className="flex items-center">
            <Loader className="w-10 h-10 animate-spin" />
            <div className="flex flex-col pl-4">
              <div className="text-sm font-bold text-gray-900">DATA LOADING</div>
              <div className="text-sm text-gray-500">Data aggregation in progress.</div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default LoadingData;
